(function(){
  if (window.fbStoryInit) { return; }
  window.fbStoryInit = true;

  function clearSel(list){
    [].forEach.call(list, function(n){ n.classList.remove('sel'); });
  }

  window.fbMode = function(el, m){
    var box = el.closest('.buybox,.finalbox');
    if (!box) { return; }
    clearSel(box.querySelectorAll('.pt'));
    el.classList.add('sel');
    [].forEach.call(box.querySelectorAll('.opt'), function(o){
      var p = o.querySelector('.p');
      var mt = o.querySelector('.meta');
      if (p && o.getAttribute('data-' + m)) { p.textContent = '$' + o.getAttribute('data-' + m); }
      if (mt && o.getAttribute('data-m' + m)) { mt.innerHTML = o.getAttribute('data-m' + m); }
    });
  };

  window.fbPick = function(el){
    clearSel(el.parentNode.querySelectorAll('.opt'));
    el.classList.add('sel');
  };

  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('.fb-jump') : null;
    if (!a) { return; }
    e.preventDefault();
    var wrap = a.closest('.fb-story');
    var custom = wrap ? wrap.getAttribute('data-cta-target') : null;
    var target = custom ? document.querySelector(custom) : null;
    if (!target) { target = document.querySelector('form[action*="/cart/add"]'); }
    if (!target) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo({ top: y, behavior: 'smooth' });
  });
})();